import { CheckCircle, RotateCcw, } from 'lucide-react'
import React, { useState } from 'react'
import { Button, Container, Modal } from 'react-bootstrap'
import { formatDateFull } from '../../../../component/solution/utils/AppUtil';
import { useAuth } from '../../../../contexts/AuthContext';
import { QueryListProvider } from '../../../../component/solution/QueryTableList/QueryListContext';
import { QueryTableList } from '../../../../component/solution/QueryTableList/QueryTableList';


export const FailedTransactions: React.FC = () => {

    const { fetchData, setRefreshTable  }  = useAuth();
    const [selectedFailedTransaction, setSelectedFailedTransaction] = useState<{key: string, function_call_id: string} | null>(null); 
    
    //Modals
    const [showFailedTransactionRerunModal, setShowFailedTransactionRerunModal] = useState<boolean>(false);
    const [showFailedTransactionHandledModal, setShowFailedTransactionHandledModal] = useState<boolean>(false);

  
    //handle the failed transaction click rerun
    const handleFailedTransactionRerunClick = (failedTransaction : {key: string, function_call_id: string}) => {
        setSelectedFailedTransaction(failedTransaction);
        setShowFailedTransactionRerunModal(true);
    }
  
    //handle the failed transaction click rerun reset
    const handleFailedTransactionRerunResetClick = () => {
       setSelectedFailedTransaction(null);
       setShowFailedTransactionRerunModal(false);
    }

    //handle the post of the failed transaction rerun sumbit 
    const handleFailedTransactionRerunSubmit = () => {
        if(selectedFailedTransaction?.key !== "" && selectedFailedTransaction?.function_call_id !== ""){
            fetchData(`${process.env.REACT_APP_BASE_URL}/functionCalls/${selectedFailedTransaction?.function_call_id}/rerun`, 
            {method:"POST", body: JSON.stringify({  })}, 
            (result: any, status: string) =>  { 
                if(status === "200"){
                    setSelectedFailedTransaction(null);
                    setRefreshTable(prev => !prev); //trigger refresh on success 
                }else{
                    setSelectedFailedTransaction(null);
                }
                
            });
                
        } else {
            return; 
        }
    }

    // //handle the failed transaction click handled
    const handleFailedTransactionHandledClick = (failedTransaction : {key: string, function_call_id: string}) => {
        setSelectedFailedTransaction(failedTransaction);
        setShowFailedTransactionHandledModal(true);
    }

    const handleFailedTransactionHandledResetClick = () => {
        setSelectedFailedTransaction(null);
        setShowFailedTransactionHandledModal(false);
    }

    const handleFailedTransactionHandledSubmit = () => {
          if(selectedFailedTransaction?.key !== "" && selectedFailedTransaction?.function_call_id !== ""){
            fetchData(`${process.env.REACT_APP_BASE_URL}/functionCalls/${selectedFailedTransaction?.function_call_id}/handle`, 
            {method:"POST", body: JSON.stringify({  })}, 
            (result: any, status: string) =>  { 
                if(status === "200"){
                    setSelectedFailedTransaction(null);
                    setRefreshTable(prev => !prev); //trigger refresh on success 
                }else{
                    setSelectedFailedTransaction(null);
                }
                
            }); 
        } else {
            return; 
        }
    }
    

    return (
      <React.Fragment>  
         <Container fluid className="p-0">
            <QueryListProvider>
                    <QueryTableList
                        listTitle={"Insights - Failed Transactions"}
                        recordTitle={"Insights - Failed Transactions"}
                        tableName={""}
                        editTableName={""}
                        hasIntegrationStatusLegend={false} 
                        errorCategoryName={''}
                        editHasCompoundKey={false}  
                        showFailedTransactionsTable={false}
                        query={{
                                appCode: "ares",
                                selectCode: "sa-ares-failed-transactions",  
                                tableName: null, 
                                where: "",
                                orderBy: "",
                                pageNum: 0,
                                pageSize: 100,
                                params: {},
                        }}   
                        orderColumns={[
                            { name: "key", type: "STRING", sortable: true, searchable: true },
                            { name: "category", type: "STRING", sortable: true, searchable: true },
                            { name: "extended_message", type: "STRING", sortable: true, searchable: true },
                            { name: "completed_at", type: "DATE", sortable: true, searchable: false }
                        ]}      
                        renderRowData={(row) => {

                            const tdStyle: React.CSSProperties = { whiteSpace: 'nowrap', border: '1px solid #deebed',  padding: '4px 8px', fontSize: '0.75rem' };
                            const tdEllipsis: React.CSSProperties = {...tdStyle, maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}
                            const tdHasDetailsOption: React.CSSProperties = { ...tdStyle,  textDecoration: 'underline', cursor: 'pointer'};

                            return (
                                <>
                                    <td style={tdStyle} title={row.key?.key}>{row.key?.key}</td>
                                    <td style={tdStyle} title={row.category}>{row.category}</td>
                                    <td style={tdEllipsis} title={row.extended_message}>{row.extended_message}</td>
                                    <td style={tdStyle} title={row.completed_at}>{formatDateFull(row.completed_at)}</td>
                                </>    
                            );
                        }}

                        renderActions={(row) => {
                        
                            return (
                                <td className="sa-record-control" style={{ border: '1px solid #deebed', height: '45px', fontSize: '0.55rem', padding: '0 5px'}}>
                                 <div className="d-flex gap-2">
                                          {/* Rerun */}
                                            <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title="Rerun"
                                               onClick={() => handleFailedTransactionRerunClick({ key: row.key?.key ?? "", function_call_id: row.function_call_id ?? ""})}
                                            >
                                                <RotateCcw  style={{ width: "17px", height: "17px" }}/>
                                            </button> 

                                            {/* Handled */}
                                            <button className="btn btn-secondary h-100 d-flex align-items-center gap-1" title="Handled"
                                               onClick={() => handleFailedTransactionHandledClick({ key: row.key?.key ?? "", function_call_id: row.function_call_id ?? ""})}
                                            >
                                                <CheckCircle style={{ width: "17px", height: "17px" }} />
                                            </button>
                                    </div>
                                </td>
                            );
                        }}   
                    />
                </QueryListProvider>


            {/* Modal Failed Transaction Rerun - Start */}
                <>
                    <Modal show={showFailedTransactionRerunModal} onHide={handleFailedTransactionRerunResetClick}>
                        <Modal.Header closeButton>
                            <Modal.Title>{`Rerun Failed [${selectedFailedTransaction?.key}] Transaction`}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                            <p>Are you sure you would like to rerun this transaction?</p>
                        </div>
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant="primary" onClick={() => { setShowFailedTransactionRerunModal(false); handleFailedTransactionRerunSubmit(); } }>
                            Confirm
                        </Button>
                        <Button variant="secondary" onClick={handleFailedTransactionRerunResetClick}>
                            Cancel
                        </Button>
                        </Modal.Footer>
                    </Modal>
                </> 
            {/*  Modal Failed Transaction Rerun - End */}


            {/* Modal Failed Transaction Handled - Start */}
                <>
                    <Modal show={showFailedTransactionHandledModal} onHide={handleFailedTransactionHandledResetClick}>
                        <Modal.Header closeButton>
                            <Modal.Title>{`Handle Failed [${selectedFailedTransaction?.key}] Transaction`}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                            <p>Are you sure you would like to mark this transaction as handled?</p>
                        </div>
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant="primary" onClick={() => { setShowFailedTransactionHandledModal(false); handleFailedTransactionHandledSubmit(); } }>
                            Confirm
                        </Button>
                        <Button variant="secondary" onClick={handleFailedTransactionHandledResetClick}>
                            Cancel
                        </Button>
                        </Modal.Footer>
                    </Modal>
                </> 
            {/*  Modal Failed Transaction Handled - End */}

        </Container>
    </React.Fragment>  
  )
}
